import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

import { UserManagerDetailComponent } from "../user-manager-detail/user-manager-detail.component";
// Import Model
import { SortCompanyModel } from "../../../../model/builk/company-manage/company-sort";
import { UserlistModel } from "../../../../model/builk/user-manager/get-users";
import { UserModel } from "../../../../model/builk/user-manager/user.model";
import { CompanyManagelistModel } from "../../../../model/builk/company-manage/company-list";
// Import Enum
import { SortType } from "../../../../enum/builk/user-manager/sort-type";
// Service
import { UserManagerService } from "../../../../service/api/builk/user-manager.service";
import { AccountStatusType } from "../../../../enum/builk/user-manager/account-status-type";
import { ChangeUserStatusModel } from "../../../../model/builk/user-manager/change-user-status.model";

@Component({
  selector: "bo-builk-user-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"]
})
export class UserTableComponent implements OnInit {
  constructor(
    public router: Router,
    private userManagerService: UserManagerService
  ) {}

  @Output()
  sortOutput = new EventEmitter<SortCompanyModel>();
  private _data = new BehaviorSubject<Array<UserlistModel>>(
    new Array<UserlistModel>()
  );
  @Input()
  set getUserDataIndex(value) {
    this._data.next(value);
  }
  get getUserDataIndex(): Array<UserlistModel> {
    return this._data.getValue();
  }
  @Output() isSaved = new EventEmitter();

  // using for sort user
  companyManagelistModel: CompanyManagelistModel = new CompanyManagelistModel();
  userDetail: UserModel = new UserModel();
  userList: UserlistModel = new UserlistModel();
  sortData: SortCompanyModel = new SortCompanyModel();
  sortUserSurr: boolean = false;
  sortEmail: boolean = false;
  sortFullname: boolean = false;
  sortPhone: boolean = false;
  sortCompanySurr: boolean = false;
  sortCompanyName: boolean = false;
  sortRole: boolean = false;
  sortDate: boolean = false;
  // sortComment: boolean = false;
  sortCompanySurrKey: boolean = false;
  sortCompanyTypesName: boolean = false;
  sortPoCount: boolean = false;
  sortProvince: boolean = false;
  sortUserStatus: boolean = false;
  // sortEmailActive: boolean = false;
  // sortDetail: boolean = false;
  // sortMailLock: boolean = false;
  @ViewChild("detailModal")detailModal: UserManagerDetailComponent;

  ngOnInit(): void {
    this._data.subscribe(x => {});
  }

  // When click header call function
  sortStatus(event: any, status: boolean): void {
    this.sortUserSurr = false;
    this.sortEmail = false;
    this.sortFullname = false;
    this.sortPhone = false;
    this.sortCompanySurr = false;
    this.sortCompanyName = false;
    this.sortRole = false;
    this.sortDate = false;
    this.sortCompanySurrKey = false;
    this.sortCompanyTypesName = false;
    this.sortPoCount = false;
    this.sortProvince = false;
    if (status) {
      // sort to DESC
      this.sortUserSurr = false;
      this.sortEmail = false;
      this.sortFullname = false;
      this.sortPhone = false;
      this.sortCompanySurr = false;
      this.sortCompanyName = false;
      this.sortRole = false;
      this.sortDate = false;
      this.sortCompanySurrKey = false;
      this.sortCompanyTypesName = false;
      this.sortPoCount = false;
      this.sortProvince = false;

      this.sortData.sortCol = event;
      this.sortData.sortType = SortType.DESC;
      this.sortOutput.emit(this.sortData);
    } else {
      // sort to ASC
      if (event === "userSurrkey") {
        this.sortUserSurr = true;
        this.sortData.sortCol = "userSurrkey";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "userEmail") {
        this.sortEmail = true;
        this.sortData.sortCol = "userEmail";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "fullName") {
        this.sortFullname = true;
        this.sortData.sortCol = "fullName";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "userPhone") {
        this.sortPhone = true;
        this.sortData.sortCol = "userPhone";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "companySurrKey") {
        this.sortCompanySurr = true;
        this.sortData.sortCol = "companySurrKey";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "companyName") {
        this.sortCompanyName = true;
        this.sortData.sortCol = "companyName";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "userRole") {
        this.sortRole = true;
        this.sortData.sortCol = "userRole";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "createdate") {
        this.sortDate = true;
        this.sortData.sortCol = "createdate";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "companySurrKey") {
        this.sortCompanySurrKey = true;
        this.sortData.sortCol = "companySurrKey";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "companyTypesName") {
        this.sortCompanyTypesName = true;
        this.sortData.sortCol = "companyTypesName";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "poCount") {
        this.sortPoCount = true;
        this.sortData.sortCol = "poCount";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "province") {
        this.sortProvince = true;
        this.sortData.sortCol = "province";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      }
    }
  }

  openModal(index): void {
    this.userDetail.userSurrKey = this._data.value[index].userSurrKey;
    this.userDetail.userName = this._data.value[index].userName;
    this.userDetail.userSurName = this._data.value[index].userSurName;
    this.userDetail.userEmail = this._data.value[index].userEmail;
    this.userDetail.userPhone = this._data.value[index].userPhone;
    this.userDetail.userAddress = this._data.value[index].userAddress;
    this.userDetail.userAmphur = this._data.value[index].userAmphur;
    this.userDetail.userCountry = this._data.value[index].userCountry;
    this.userDetail.userLanguage = this._data.value[index].userLanguage;
    this.userDetail.userAvatar = this._data.value[index].userAvatar;
    this.userDetail.obsolete = this._data.value[index].obsolete;
    this.userDetail.comment = this._data.value[index].comment;
    this.userDetail.poCount = this._data.value[index].poCount;
    this.userDetail.createdDateUser = this._data.value[index].createdDateUser;
    this.userDetail.createdDateEmployee = this._data.value[index].createdDateEmployee;
    this.userDetail.companySurrKey = this._data.value[index].companySurrKey;
    this.userDetail.companyName = this._data.value[index].companyName;
    this.userDetail.companyTypesName = this._data.value[index].companyTypesName;
    this.userDetail.companyProvince = this._data.value[index].companyProvince;
    this.userDetail.roles = this._data.value[index].roles;
    this.userDetail.emailConfirmed = this._data.value[index].emailConfirmed;
    this.userDetail.lockoutEnabled = this._data.value[index].lockoutEnabled;
    this.userDetail.accessFailedCount = this._data.value[index].accessFailedCount;
    this.userDetail.isRegister = this._data.value[index].isRegister;
    this.userDetail.activateDate = this. _data.value[index].activateDate;
    this.userManagerService.getUserCompanyList(this.userDetail.userSurrKey)
    .subscribe(
      Response => {
        this.companyManagelistModel = Response;
        this.checkLockUserEmail(this.userDetail.userEmail);
      },
      err => {
        console.log("Can't checkLockUserEmail");
      }
    );
  }

  // validate by id
  updateComment(index: number, comment: string): void {
    this.userList.comment = this._data.value[index].comment;
    this.userList.userSurrKey = this._data.value[index].userSurrKey;
    this.userList.companySurrKey = this._data.value[index].companySurrKey;
    this.userList.employeeSurrKey = this._data.value[index].employeeSurrKey;
    this.userManagerService.updateCommentBackOffice(this.userList)
    .subscribe(
      Response => {
      },
      err => {
        console.log("Can't updateComment");
      }
    );
  }

  checkLockUserEmail(userEmail: string): void {
    this.userList.userEmail = userEmail;
    const encodeEmail = encodeURIComponent(this.userList.userEmail);
    this.userManagerService.checkUserEmail(encodeEmail)
    .subscribe(
      response => {
        this.userDetail.statusEmail = response;
        this.userDetail.lockoutEnabled = this.userDetail.statusEmail === "enable" ? true : false;
        this.detailModal.openModal(this.userDetail);
      },
      err => {
        // unauthorized refresh token
        console.log("Can't checkLockUserEmail");
      }
    );
  }

  getUserStatus(type) {
    switch (type) {
      case AccountStatusType.Inactive:
        return "Inactive";
      case AccountStatusType.Active:
        return "Active";
      case AccountStatusType.Unknown:
      default:
        return "Unknown"
    }
  }

  getUserStatusStyle(type) {
    switch (type) {
      case AccountStatusType.Inactive:
        return "btn-danger";
      case AccountStatusType.Active:
        return "btn-success";
      case AccountStatusType.Unknown:
      default:
        return "btn-warning"
    }
  }

  changeUserStatus(data: UserlistModel) {
    if (data.userInactiveStatus == AccountStatusType.Unknown) return;
    var model = new ChangeUserStatusModel();
    model.userSurrkey = data.userSurrKey;
    model.userStatus = data.userInactiveStatus;
    this.userManagerService.changeUserStatus(model)
    .subscribe(
      Response => {
        if (Response) {
          this.sortOutput.emit(this.sortData);
        }
      },
      err => {
        console.log("Can't change user status");
      }
    );
  }
}
